import styled from 'styled-components';

const Container = styled.div`
  box-sizing: initial;
  width: 59.5rem;
  max-width: 100%;
  padding: 0 1.375rem;

  * {
    box-sizing: border-box;
  }
`;

export default Container;